import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

filterStyles.fromGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    flex-basis: 30%;
                    max-width: 30%;
                `,
                null,
                null,
            ])}
        > div {
            width: 100%;
        }
    `,
};
filterStyles.toGridItem = {
    width: [12, 6, 3, 3, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    flex-basis: 30%;
                    max-width: 30%;
                `,
                null,
                null,
            ])}

        > div {
            width: 100%;
        }
    `,
};
filterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                padding: 8px;
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        padding: 0px 10px 0px 0px;
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                padding: 8px;
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            margin-right: 5px;
                                            > span[class^="IconWrapper"] {
                                                padding: 8px;
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                padding: 8px;
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                padding: 8px;
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                ])}
        `,
    },
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                width: 34px;
                                                height: 36px;
                                                background: #ffffff;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                width: 34px;
                                                height: 36px;
                                                background: #ffffff;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            margin-right: 5px;
                                            > span[class^="IconWrapper"] {
                                                width: 34px;
                                                height: 36px;
                                                background: #ffffff;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                width: 34px;
                                                height: 36px;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    css`
                        > div[class^="FormInputWrapper"] {
                            div[class^="DateTimePickerStyle"] {
                                > div {
                                    padding: 0px 4px 0px 2px;
                                    > div[class^="react-datetime-picker"] {
                                        > button {
                                            width: 34px;
                                            > span[class^="IconWrapper"] {
                                                width: 34px;
                                                height: 36px;
                                                background: #ffffff;
                                                border-radius: 100%;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                ])}
        `,
    },
};
